import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchInvoices } from '../../../../actions/invoice/invoiceList'
import Invoices, { Row } from '../../Invoices'
import { AppState } from '../../../../reducers'
import { FiltersBar, Filters } from '../../../Utils/Filters/Filter'
import { FilterFromDate, FilterToDate, FilterClientName, FilterReceipts, FilterTel } from '../../../Utils/Filters'
import { InvoiceListState } from '../../../../reducers/invoice/invoiceList'
import { InvoiceAzureState } from '../../../../reducers/invoice/invoicesAzure'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import Invoice from '../../../../models/Invoice'
import { SessionState, isAdmin, isClient, isHeadSales, isManager, isStaff, isVendor } from '../../../../reducers/auth/session'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { Stack } from '@mui/material'
import { downloadAzureFile } from '../../../Utils/downloadAzureFile'
import { fetchInvoiceAzure } from '../../../../actions/invoice/invoiceAzure'
import InvoiceAzure from '../../../../models/InvoiceAzure'
import { upsertInvoiceStatus } from '../../../../actions/invoice/invoiceStatusUpsert'
import BouncedReceipt from '../../../../models/BouncedReceipt'
import { BouncedReceiptListState } from '../../../../reducers/bouncedReceipt/bouncedReceiptList'
import { fetchBouncedReceipts } from '../../../../actions/bouncedReceipt/bouncedReceiptList'
import Pagination from '../../../../models/Pagination'
import { getToken } from '../../../../utils/fetchApi'

interface Props {
  fullInfo?: boolean
  invoiceList: InvoiceListState
  bouncedReceiptList: BouncedReceiptListState
  invoiceAzure: InvoiceAzureState
  session: SessionState
}

export interface UnifiedInvoiceRow {
  source: 'invoice' | 'bounced';
  id: string;
  fecha: string;
  numero: number | string;
  codigo_cliente: number | null | undefined;
  fecha_vencimiento?: string;
  importe_total: number;
  tipo: string;
  sucursal: number;
  status: string | null | undefined;
  data: Invoice | BouncedReceipt;
}


const InvoiceList: React.FC<Props> = ({ invoiceList, bouncedReceiptList, session, invoiceAzure, fullInfo = true }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation(['invoice', 'client'])
  const [fileAzure, setFileAzure] = useState<string>('')
  const [docVentas, setDocVentas] = useState<InvoiceAzure | null>(null)
  const [docBouncedReceipt, setDocBouncedReceipt] = useState<BouncedReceipt | null>(null)
  const [invoiceStatus, setInvoiceStatus] = useState<string | null>(null)
  const [forceReRead, setForceReRead] = useState<boolean>(false)
  const [visibleRows, setVisibleRows] = useState<UnifiedInvoiceRow[]>([])
  const [mergedPagination, setMergedPagination] = useState<Pagination | undefined>(undefined)

  useEffect(() => {
    setForceReRead(false)
    dispatch(fetchInvoices(history.location.search ? `${history.location.search}&limit=25` : `?limit=25`))
    dispatch(fetchBouncedReceipts(history.location.search ? `${history.location.search}&limit=25` : `?limit=25`))
  }, [dispatch, history.location.search, forceReRead])

  const initDefaultFilters: Filters = {
    invoiceFrom: moment().startOf('year').subtract(1, 'years').tz("America/Argentina/Buenos_Aires").format(),
    invoiceTo: moment().endOf('month').tz("America/Argentina/Buenos_Aires").format(),
  }

  /*
  dueFrom: moment().year(2000).startOf('year').tz("America/Argentina/Buenos_Aires").format(),
  dueTo: moment().year(2099).endOf('year').tz("America/Argentina/Buenos_Aires").format(),
  <FilterFromDate name="dueFrom" label={t("fromDueDate")} />
  <FilterToDate name="dueTo" label={t("toDueDate")} />
  */

  /*
  useEffect(() => {
    if (fileAzure) {
      window.location.assign(fileAzure)
      if (!invoiceStatus && isClient(session))
        dispatch(upsertInvoiceStatus({
          id: null, invoiceId: docVentas ? `${docVentas.tipo} ${docVentas.sucursal.toString().padStart(4, '0')}-${docVentas.numero.toString().padStart(8, '0')}` : docBouncedReceipt ? docBouncedReceipt.registro.toString() : null,
          status: 'D',
          recordId: docVentas ? docVentas.registro : docBouncedReceipt ? docBouncedReceipt.registro : null
        }, () => { setDocVentas(null); setDocBouncedReceipt(null); setInvoiceStatus(null); setForceReRead(true) }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [fileAzure])
  */

  useEffect(() => {
    if (fileAzure) {
      (async () => {
        try {
          const res = await fetch(`${process.env.REACT_APP_API_URL}/invoiceDownloadCheck?url=${encodeURIComponent(fileAzure)}`, {
            headers: { Authorization: `Bearer ${getToken()}` }
          });
          const data = await res.json();

          if (data.exists) {
              // El archivo existe: abrir en nueva pestaña o ventana
              window.location.assign(fileAzure);
              // Solo marcar como descargado si es cliente y aún no tiene estado
              if (!invoiceStatus && isClient(session)) {
                dispatch(upsertInvoiceStatus({
                  id: null, invoiceId: docVentas ? `${docVentas.tipo} ${docVentas.sucursal.toString().padStart(4, '0')}-${docVentas.numero.toString().padStart(8, '0')}` : docBouncedReceipt ? docBouncedReceipt.registro.toString() : null,
                  status: 'D',
                  recordId: docVentas ? docVentas.registro : docBouncedReceipt ? docBouncedReceipt.registro : null
                }, () => { setDocVentas(null); setDocBouncedReceipt(null); setInvoiceStatus(null); setForceReRead(true) }))
              }
            } else {
              // No existe o no accesible (404, 403, etc.)
              console.error('Archivo inexistente o inaccesible:', res.status);
              window.alert('No se pudo descargar el comprobante. El comprobante no está disponible en este momento. Intente más tarde.');
            }
          } catch (err) {
            console.error('Error verificando el comprobante:', err);
            window.alert('Error al intentar verificar y descargar el comprobante. El archivo no está disponible en este momento. Intente más tarde.');
          }
        })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileAzure]);



  const linkToInvoiceDetail = (data: UnifiedInvoiceRow) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}${data.tipo === 'CR' ? `/bouncedReceipts/detailId/${(data.data as BouncedReceipt).registro}` : `/accounts/detail/${(data.data as Invoice).id_factura}`}`
    history.push(detailUrl)
  }

  const handleAzureFile = (doc: InvoiceAzure) => {
    setDocVentas(doc)
    setFileAzure(downloadAzureFile(doc.pathpdfazure, doc.nombrepdf, doc.tipo === 'FE' || doc.tipo === 'CE' || doc.tipo === 'DE' ? 'ME' : ''));
  }

  const handleBouncedReceiptAzureFile = (doc: BouncedReceipt) => {
    setDocBouncedReceipt(doc)
    setFileAzure(downloadAzureFile(doc.pathpdfazure, doc.nombre_pdf, 'CR'));
  }


  const handleErrorAzureFile = (err: Error) => {
    window.alert(err.message);
  }

  const downloadInvoice = (row: Row) => {
    const clientParam = isAdmin(session) || isManager(session) || isStaff(session) || isHeadSales(session) || isVendor(session) ? `&codigocliente=${row.data.codigo_cliente}` : ''
    const params = `?tipo=${row.data.tipo}&sucursal=${row.data.sucursal}&numero=${row.data.numero}${clientParam}`
    setInvoiceStatus(row.data.status ? row.data.status : null)
    if (row.data.source === 'invoice')
      dispatch(fetchInvoiceAzure(params, handleAzureFile, handleErrorAzureFile))
    else
      handleBouncedReceiptAzureFile(row.data.data as BouncedReceipt)
  }


  useEffect(() => {
    if (invoiceList && !invoiceList.isFetching && bouncedReceiptList && !bouncedReceiptList.isFetching) {
      const invoiceRows: UnifiedInvoiceRow[] = invoiceList && invoiceList.invoices ? invoiceList.invoices.map(inv => ({
        source: 'invoice',
        id: inv.id_factura,
        fecha: inv.fecha,
        codigo_cliente: inv.codigo_cliente,
        numero: inv.factura_numero,
        sucursal: inv.factura_prefijo,
        fecha_vencimiento: inv.fecha_vencimiento,
        importe_total: inv.importe_total_comprobante,
        tipo: inv.factura_comprobante,
        status: inv.status,
        data: inv as Invoice
      })) : [];


      const bouncedRows: UnifiedInvoiceRow[] = bouncedReceiptList &&
        bouncedReceiptList.bouncedReceipts ? bouncedReceiptList.bouncedReceipts.map(rec => ({
          source: 'bounced',
          id: String(rec.registro),
          fecha: rec.fecha,
          codigo_cliente: rec.codigo_cliente,
          numero: rec.numero,
          sucursal: rec.sucursal,
          fecha_vencimiento: rec.vencimiento,
          importe_total: rec.importe_total,
          tipo: rec.tipo,
          status: rec.status,
          data: rec as BouncedReceipt
        })) : [];

      const combined = [...invoiceRows, ...bouncedRows]
        .sort((a, b) => new Date(b.fecha).getTime() - new Date(a.fecha).getTime());

      setVisibleRows(combined);
      const totalCount = (invoiceList.pagination?.count || 0) + (bouncedReceiptList.pagination?.count || 0)
      const currentPage = invoiceList.pagination?.page || 0

      setMergedPagination({
        size: invoiceList.pagination?.count ? invoiceList.pagination.size : bouncedReceiptList.pagination.size,
        count: totalCount,
        page: currentPage
      })

    }
  }, [invoiceList, bouncedReceiptList]);

  return (
    <Stack style={{ height: fullInfo ? (isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)) ? '' : 'calc(100% - var(--header-height)' : '' }}>
      {fullInfo &&
        <FiltersBar defaultFilters={initDefaultFilters}>
          <FilterFromDate name="invoiceFrom" label={t("fromDate")} />
          <FilterToDate name="invoiceTo" label={t("toDate")} />
          <FilterTel name="invoiceNumber" label={t("number")} />
          <FilterReceipts name="receipts" label={t("receipt")} />
          {(isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)) ? <FilterClientName name="codigo_cliente" label={t('title', { ns: 'client' })} /> : <></>}
        </FiltersBar>}
      <Invoices
        //rows={(invoiceList.invoices || []).map(s => ({ data: s }))}
        rows={visibleRows.map(s => ({ data: s }))}
        loading={invoiceList.isFetching || bouncedReceiptList.isFetching}
        fullInfo={fullInfo}
        adminInfo={isAdmin(session) || isManager(session) || isHeadSales(session) || isStaff(session)}
        pagination={mergedPagination || undefined}
        showDownloadButton={true}
        onClickInfo={linkToInvoiceDetail}
        onClickDownload={downloadInvoice}
      />
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  invoiceList: state.invoiceList,
  bouncedReceiptList: state.bouncedReceiptList,
  invoiceAzure: state.invoiceAzure,
  session: state.session
})

export default connect(mapStateToProps, null)(InvoiceList)